export const TYPES = {
    MICRO_COMPUTER_PROTECT_SOE_ALARM_ALL: '微机综保报警(SOE)',
    MICRO_COMPUTER_PROTECT_SOE_ALARM_01: '微机综保报警(远方控制)',
    MICRO_COMPUTER_PROTECT_SOE_ALARM_02: '微机综保报警(开关位置)',
    MICRO_COMPUTER_PROTECT_SOE_ALARM_03: '微机综保报警(手车位置)',
    MICRO_COMPUTER_PROTECT_SOE_ALARM_04: '微机综保报警(接地刀位置)',
    MICRO_COMPUTER_PROTECT_SOE_ALARM_05: '微机综保报警(开入0)',
    MICRO_COMPUTER_PROTECT_SOE_ALARM_06: '微机综保报警(开入1)',
    MICRO_COMPUTER_PROTECT_SOE_ALARM_07: '微机综保报警(开入2)',
    MICRO_COMPUTER_PROTECT_SOE_ALARM_08: '微机综保报警(储能位置)',
    MICRO_COMPUTER_PROTECT_SOE_ALARM_09: '微机综保报警(跳闸位置)',
    MICRO_COMPUTER_PROTECT_SOE_ALARM_10: '微机综保报警(合闸位置)',
    MICRO_COMPUTER_PROTECT_SOE_ALARM_11: '微机综保报警(复归位置)',
    MICRO_COMPUTER_PROTECT_SECURITY_ALARM_ALL: '微机综保报警(储能位置)',
    MICRO_COMPUTER_PROTECT_SECURITY_ALARM_01: '微机综保报警(过流Ⅰ段动作)',
    MICRO_COMPUTER_PROTECT_SECURITY_ALARM_02: '微机综保报警(过流Ⅱ段动作)',
    MICRO_COMPUTER_PROTECT_SECURITY_ALARM_03: '微机综保报警(过载保护动作)',
    MICRO_COMPUTER_PROTECT_SECURITY_ALARM_04: '微机综保报警(反时限保护动作)',
    MICRO_COMPUTER_PROTECT_SECURITY_ALARM_05: '微机综保报警(0零序过流动作)',
    MICRO_COMPUTER_PROTECT_SECURITY_ALARM_06: '微机综保报警(1零序过压动作)',
    MICRO_COMPUTER_PROTECT_SECURITY_ALARM_07: '微机综保报警(负序过流保护动作)',
    MICRO_COMPUTER_PROTECT_SECURITY_ALARM_08: '微机综保报警(2开入0动作)',
    MICRO_COMPUTER_PROTECT_SECURITY_ALARM_09: '微机综保报警(开入1动作)',
    MICRO_COMPUTER_PROTECT_SECURITY_ALARM_10: '微机综保报警(开入2动作)',
    MICRO_COMPUTER_PROTECT_SECURITY_ALARM_11: '微机综保报警(PT断线保护动作)',
    MICRO_COMPUTER_PROTECT_SECURITY_ALARM_12: '微机综保报警(CT断线保护动作)',
  }